import styled from 'styled-components'

export const AccordionContainer = styled.div`
  width: 100%;
  padding: 0 24px;
  box-sizing: border-box;
`

export const AccordionItem = styled.div`

`

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  cursor: pointer;
  border-bottom: 1px solid rgba(22, 22, 22, 0.24);
`

export const AccordionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  font-size: 16px;
  font-weight: 700;
  color: #000E40;
`

export const AccordionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0)'};
  color: rgba(22, 22, 22, 0.88);
`

export const AccordionContent = styled.div`
  padding: ${props => props.isOpen ? '16px' : '0'};
  max-height: ${props => props.isOpen ? '500px' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
`

export const Button = styled.button`
  width: 100%;
  padding: 12px 16px;
  text-align: left;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: #F3F4F6;
  }
`

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  margin: 0 auto;
  background: rgba(22, 22, 22, 0.24);
  display: ${props => props.isOpen ? 'block' : 'none'};
`;
